<div class="row middle-xs background" *ngIf="show">
    <div class="col-xs-11" (click)="open()">
        <p class="subscribe-text">Suscríbete <span class="here">aquí</span> a nuestras promociones</p>
    </div>
    <div class="col-xs-1">
        <mat-icon (click)="close()">close</mat-icon>
    </div>
</div>
